/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Per-competition points multiplier of one problem.
 * @export
 * @interface CompetitionProblemUpdate
 */
export interface CompetitionProblemUpdate {
    /**
     * 
     * @type {number}
     * @memberof CompetitionProblemUpdate
     */
    points_multiplier: number;
}

/**
 * Check if a given object implements the CompetitionProblemUpdate interface.
 */
export function instanceOfCompetitionProblemUpdate(value: object): value is CompetitionProblemUpdate {
    if (!('points_multiplier' in value) || value['points_multiplier'] === undefined) return false;
    return true;
}

export function CompetitionProblemUpdateFromJSON(json: any): CompetitionProblemUpdate {
    return CompetitionProblemUpdateFromJSONTyped(json, false);
}

export function CompetitionProblemUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionProblemUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'points_multiplier': json['points_multiplier'],
    };
}

export function CompetitionProblemUpdateToJSON(json: any): CompetitionProblemUpdate {
    return CompetitionProblemUpdateToJSONTyped(json, false);
}

export function CompetitionProblemUpdateToJSONTyped(value?: CompetitionProblemUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'points_multiplier': value['points_multiplier'],
    };
}

